export const PAYMENT_HEADER = {
	subHeaderText: 'Paying to:',
	amount: 'Amount',
};
export const PAYABLE_AMOUNT = {
	payableAmount: 'Payable Amount',
	xFastTag: 'x 2FASTag',
	completeYourPayment: 'Complete Your Payment',
	idVpaEntered: 'ID / VPA entered: ',
	open: 'Open ',
	googlePay: 'Google Pay ',
	app: 'App',
	checkingPaymentRequest: 'Check pending requests &\n',
	completeThisPaymentIn: 'Complete this payment in',
	dontGoBack: `Please don't go back or refresh until payment is completed`,
	safeAndSecure: '100% SAFE & SECURE',
	transactionStatus: 'Check Transaction Status',
};

export const UPI_INTENT_CONSTANT = {
	PSP_MODAL_STATUS: {
		NO_PSP_INSTALLED: 'NO_PSP_INSTALLED',
		INVALID_PARAMS: 'INVALID_PARAMS',
		USER_CLOSED: 'USER_CLOSED',
	},
	MESSAGE_CONSTANT: {
		NO_PSP_APP_FOUND: 'No App Found',
		SOMETHING_WRONG: 'Please try again or use a different app',
	},
};
